import { CompleteTemplateConfigType } from '#src/utils';

const config: CompleteTemplateConfigType = {
  dynamicComponents: {
    PAYMENT_FORM_TITLE: {
      template: 'standard',
      params: {
        title: {
          contentKey: 'paymentpage.secure.title',
        },
        subtitle: {
          contentKey: 'paymentpage.security',
        },
        lockIcon: {
          isVisible: true,
        },
      },
    },
    FEEDBACK_MODAL: {
      template: 'standard',
      params: {
        title: {
          contentKey: 'paymentpage.feedback.success.title',
        },
        subtitle: {
          contentKey: 'paymentpage.feedback.success.subtitle',
        },
        successButton: {
          contentKey: 'paymentpage.feedback.success.button',
        },
      },
    },
    HEADER: {
      template: 'standard',
      params: {
        title: {
          contentKey: 'paymentpage.page.title',
        },
        subtitle: {
          isVisible: false,
        },
        backButton: {
          contentKey: 'paymentpage.page.back.button',
          isVisible: true,
        },
      },
    },
    CTA_BOX: {
      template: 'standard',
      params: {
        title: {
          contentKey: 'paymentpage.purchase.title',
          isVisible: true,
        },
        purchaseButton: {
          contentKey: 'paymentpage.purchase.button',
        },
        totalPrice: {
          isVisible: true,
        },
        priceBreakdown: {
          isVisible: true,
        },
      },
    },
    PROMO_CODE_WIDGET: {
      template: 'standard',
      params: {
        promoCode: {
          isVisible: false,
        },
      },
    },
  },
};

export default config;
